import React, { useEffect, useMemo, useState } from "react";
import "./index.css";
import { MdAccessAlarm, MdOutlineDashboard } from "react-icons/md";
import { GoBell } from "react-icons/go";
import { AiOutlineSync } from "react-icons/ai";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Button, Card, Popover } from "antd";
import { title, clickContent } from "./content";
import { ProfileModal } from "./content";
import { sync } from "../../functions/auth";
import { useDispatch, useSelector } from "react-redux";
import { loaderReducer } from "../toolkit/loader";
import { toast } from "react-toastify";
import { CgProfile } from "react-icons/cg";
import Cookies from "universal-cookie";
import axios from "axios";
import moment from "moment";
import { syncReducer } from "../toolkit/syncReducer";

const isSandbox =
  process.env?.REACT_APP_SANDBOX ?? process.env.REACT_APP_SANDBOX;

const Header = () => {
  const [clicked, setClicked] = useState(false);
  const [hovered, setHovered] = useState(false);
  const [activeContent, setActiveContent] = useState(null);
  const location = useLocation();
  const dispatch = useDispatch();
  const cookies = new Cookies();
  const token = cookies.get("token");
  const [unreadNotifications, setUnreadNotifications] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API}/notification/list-all`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              notificationtype: "widget",
            },
          }
        );

        const unread = response.data.data.unreadNotifications;
        setUnreadNotifications(unread);
      } catch (error) {
        console.error("Failed to fetch notifications:", error);
      }
    };

    fetchNotifications();
  }, []);

  const handleCardClick = (tranId) => {
    navigate(`/work-order`, { state: { tranId } });
  };

  const handleItemClick = (content) => {
    setActiveContent(content);
  };

  const hide = () => {
    setClicked(false);
    setHovered(false);
  };
  const handleHoverChange = (open) => {
    setHovered(open);
    setClicked(false);
  };
  const handleClickChange = (open) => {
    setHovered(false);
    setClicked(open);
  };

  // const handleSync = () => {
  //   dispatch(loaderReducer(true));
  //   try {
  //     sync()
  //       .then((res) => {
  //         dispatch(loaderReducer(false));
  //         toast.success(res.data.message);
  //         console.log("handleSync", res);
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //         dispatch(loaderReducer(false));
  //         toast.error(err);
  //       });
  //   } catch (error) {
  //     dispatch(loaderReducer(false));
  //     toast.error(error);
  //   }
  // };

  const handleSync = () => {
    // Dispatch loaderReducer to true before starting the API call
    dispatch(loaderReducer(true));

    // Call the sync API
    axios
      .get(`${process.env.REACT_APP_API}/sync`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      })
      .then((response) => {
        // Dispatch loaderReducer to false after the API call is successful
        dispatch(loaderReducer(false));
        dispatch(syncReducer("syncingComplete"));
        // Show success toast
        toast.success("Sync completed successfully");
        // console.log("Sync successful", response);
      })
      .catch((error) => {
        // Dispatch loaderReducer to false if an error occurs
        dispatch(loaderReducer(false));
        // Show error toast
        toast.error("An error occurred during sync");
        console.error("Sync error", error);
      });
  };

  // console.log("activeContent", location.pathname, activeContent);
  return (
    <div
      className="hmain"
      style={{
        // Dynamic background based on environment
        background: isSandbox === 'true' || isSandbox === true ? '#a21010' : '#414c60'
      }}
    >
      <Link
        // #FF3535
        to="/dashboard"
        style={{
          textDecoration: "none",
          color: "white",
          // color:
          //   activeContent === "Sync"
          //     ? "#c2cddd"
          //     : activeContent === "Profile"
          //     ? "#c2cddd"
          //     : location.pathname === "/dashboard"
          //     ? "white"
          //     : "#c2cddd",
        }}
        onClick={() => handleItemClick("Jupiter")}
      >
        <div className="d-flex gap-2 justify-content-center">
          <img
            alt=""
            src="/images/Union.png"
            style={{ width: "30px", height: "24px" }}
          />
          <h2 className="header">Pronto</h2>
          {(isSandbox === 'true' || isSandbox === true) && (
            <h2 className="header" style={{ marginLeft: "10px" }}>
              SANDBOX
            </h2>
          )}
        </div>
      </Link>
      <div className="headerrem">
        <Link
          to="/dashboard"
          style={{
            textDecoration: "none",
            color:
              activeContent === "Sync"
                ? "#c2cddd"
                : activeContent === "Profile"
                  ? "#c2cddd"
                  : location.pathname === "/dashboard"
                    ? "white"
                    : "#c2cddd",
          }}
          onClick={() => handleItemClick("Dashboard")}
        >
          <div className="iconflex">
            <div className="fonticon">
              <MdOutlineDashboard />
            </div>
            Dashboard
          </div>
        </Link>
        {/* <Link to="/skykit-monitor"> */}
        {/*   <div className="iconflex"> */}
        {/*     <div className="fonticon"> */}
        {/*       <MdAccessAlarm /> */}
        {/*     </div> */}
        {/*     Skykit Monitor          </div> */}
        {/**/}
        {/* </Link> */}

        {/* Popover for update */}

        <Popover
          content={
            unreadNotifications.length > 0 ? (
              unreadNotifications.map((notification) => (
                <div key={notification.id} className="mt-3">
                  <Card
                    hoverable
                    className="cardcls"
                    style={{
                      width: "400px",
                    }}
                    onClick={() => handleCardClick(notification.tranId)}
                  >
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="prioritycls text-dark p-0">
                        {moment(notification.createdAt).format("MM/DD/YYYY")}
                      </div>
                      <div className="updatenote">{notification.type}</div>
                    </div>
                    <div className="mt-2">Order #{notification.tranId}</div>
                  </Card>
                </div>
              ))
            ) : (
              <p>No new notifications</p>
            )
          }
          title={
            <div>
              <div className="d-flex justify-content-between">
                <div className="update">Updates</div>
                <div className="updatehead" style={{ fontWeight: "400" }}>
                  <Button onClick={() => navigate("/update")}>
                    View All Updates
                  </Button>
                </div>
              </div>
              <div className="mt-3 updatehead">Unread</div>
            </div>
          }
          trigger="hover"
          open={clicked}
          onOpenChange={handleClickChange}
        >
          <Link
            to="/update"
            style={{
              textDecoration: "none",
              color:
                activeContent === "Sync"
                  ? "#c2cddd"
                  : activeContent === "Profile"
                    ? "#c2cddd"
                    : location.pathname === "/update"
                      ? "white"
                      : "#c2cddd",
            }}
            onClick={() => handleItemClick("Updates")}
          >
            <div className="iconflex">
              <div className="fonticon">
                <GoBell />
              </div>
              Updates
            </div>
          </Link>
        </Popover>

        {/* Popover for update */}
        {/* {<div */}
        {/*   className="iconflex" */}
        {/*   onClick={() => { */}
        {/*     handleSync(); */}
        {/*     handleItemClick("Sync"); */}
        {/*   }} */}
        {/*   style={{ color: activeContent === "Sync" ? "white" : "#c2cddd" }} */}
        {/* > */}
        {/*   <div className="fonticon"> */}
        {/*     <AiOutlineSync /> */}
        {/*   </div> */}
        {/*   Sync */}
        {/* </div>} */}

        {/* Profile for logout */}
        <Link
          to="/profile"
          style={{
            textDecoration: "none",
            color:
              activeContent === "Sync"
                ? "#c2cddd"
                : activeContent === "Profile"
                  ? "#c2cddd"
                  : location.pathname === "/update"
                    ? "white"
                    : "#c2cddd",
          }}
          onClick={() => handleItemClick("Profile")}
        >
          <div
            className="iconflex"
            style={{ color: activeContent === "Profile" ? "white" : "#c2cddd" }}
          >
            <div className="fonticon">
              <CgProfile />
            </div>
            Profile
          </div>
        </Link>
      </div>
    </div>
  );
};

export default Header;
